import React from "react";
import { Card, Table, Typography } from 'antd';
import 'dayjs/locale/uk';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { useGetUserDetailsQuery } from '../../services/auth/authService'
const { Text } = Typography;

const HistorySubComponent = () => {
    const { data: userInfo = {}, isFetching: isUserInfoFetching } = useGetUserDetailsQuery()
    dayjs.extend(LocalizedFormat);
    const columns = [
        {
            title: 'Дата',
            dataIndex: 'date',
            key: 'date',
            width: '45%',
            render: (date) => dayjs(date).locale('uk').format('LLLL')
        },
        {
            title: 'Хто поповнив',
            key: 'paid_by',
            width: '30%',
            render: (_, record) => {
                if (record.paid_by_name && record.paid_by_phone) return `${record.paid_by_name} (${record.paid_by_phone})`;
                return record.paid_by_name || record.paid_by_phone || '-';
            }
        },
        {
            title: 'Сума',
            dataIndex: 'amount',
            key: 'amount',
            width: '25%',
            render: (amount) => parseInt(amount) >= 0 ? `+${amount}` : amount
        },
    ];
    return (
        <Card className="compact-section-card" bordered={false}>
            <div className="compact-section-head">
                <Text className="compact-section-title">Історія операцій</Text>
                <Text className="compact-section-subtitle">
                    {userInfo.transactions?.length || 0} записів
                </Text>
            </div>
                <Table
                    className="compact-table"
                    bordered
                    scroll={{
                        x: 560,
                        y: 500,
                    }}
                    columns={columns}
                    rowKey={(record) => record.id}
                    pagination={false}
                    dataSource={userInfo.transactions}
                    rowClassName={(record) => parseInt(record.amount) < 0 ? 'amount-negative' : 'amount-positive'}
                    size="small"
                    loading={isUserInfoFetching}
                />
        </Card>
    )
}

export default HistorySubComponent
